import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { PageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class PageDeletePageResolve implements Resolve<any> {

  constructor(private pageService: PageService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.pageService.deletePage(
      route.data.id || route.params.id || route.queryParams.id
    );
  }
}
